// @mui
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
// types
//
import AccountMemberships from './account-memberships';
import AccountBillingPayment from './account-billing-payment';
import AccountBillingHistory from './account-billing-history';
import AccountBillingAddress from './account-billing-address';
import {
  AccountCreditBalanceEntryDto,
  AccountDto,
  AddressDto,
  InvoiceDto,
  MembershipDto,
  PaymentMethodDto,
} from '../../api';
// redux
import { useSelector } from '../../redux/store';
// components
import AccountBalanceHistory from './account-balance-history';
import WaitingListCard from './waiting-list';

// ----------------------------------------------------------------------

type Props = {
  plans: MembershipDto[];
  cards: PaymentMethodDto[];
  invoices: InvoiceDto[];
  addressBook: AddressDto[];
  member: AccountDto;
  entries: AccountCreditBalanceEntryDto[];
  handleAddNewMembership: VoidFunction;
};

export default function AccountBilling({
  cards,
  plans,
  invoices,
  addressBook,
  member,
  entries,
  handleAddNewMembership,
}: Props) {
  const waitingList = useSelector((state) => state.member.currentMemberWaitingList);

  return (
    <Grid container spacing={5}>
      <Grid size={{ xs: 12, md: 8 }}>
        <Stack spacing={3}>
          <AccountMemberships
            plans={plans}
            cardList={cards}
            member={member}
            handleAddNewMembership={handleAddNewMembership}
          />

          <WaitingListCard member={member} waitingList={waitingList} />

          {cards.length > 0 && <AccountBillingPayment cards={cards} member={member} />}

          <AccountBillingAddress addressBook={addressBook} member={member} />
        </Stack>
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Stack spacing={3}>
          <AccountBalanceHistory entries={entries} member={member} />

          <AccountBillingHistory invoices={invoices} />
        </Stack>
      </Grid>
    </Grid>
  );
}
